<template>
  <div class="buy">
    <button class="btn-buy" @click="showSku = true">点击购买</button>
    <van-sku
      v-model="showSku"
      :sku="sku"
      :goods="goods"
      :initial-sku="initialSku"
      hide-stock
      hide-quota-text
      :show-add-cart-btn="false"
      @buy-clicked="onBuyClicked"
      get-container="body"
    />
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'DetailPay',
    props: {
      product: Array,
    },
    data() {
      return {
        showSku: false, // 显示商品规格
        sku: {
          tree: [
            {
              k: '课程',
              v: [],
              k_s: 'course',
            },
          ],
          list: [],
          stock_num: 0,
          price: '0.00', // 默认价格（单位元）
        }, // 商品 sku 数据
        goods: {
          picture: '',
        }, // 商品信息
        initialSku: {
          course: '',
        }, // 默认选中的 sku
      };
    },
    created() {
      this.product.forEach((item, index) => {
        this.sku.tree[0].v.push({
          id: item.cno,
          name: item.courseName,
          imgUrl: item.banner,
        });

        this.sku.list.push({
          id: item.cno,
          course: item.cno,
          price: item.price * 100,
          stock_num: 1,
        });

        this.sku.stock_num += 1;

        if (index === 0) {
          this.sku.price = `${item.price}.00`;
          this.goods.picture = item.banner;
          this.initialSku = {
            course: item.cno,
          };
        }
      });
    },
    methods: {
      // 下单
      onBuyClicked(sku) {
        this.showLoading();

        const cno = sku.selectedSkuComb.id;
        this.getOrderNo(cno).then(({ data: { code, data } }) => {
          if (code === 200) {
            this.hideLoading();
            const url = `https://vip.zhuokao360.com/pay/order.html?order_no=${data}`;
            window.location.href = url;
          }
        });
      },

      // 获取订单编号
      getOrderNo(cno) {
        return axios.post(
          `https://api.zhuokao360.com/xtbPay/addOrder?cNo=${cno}`,
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
.btn-buy {
  width: 100%;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #30c27b;
  border-radius: 4px;
  animation: 1.5s infinite slidein;
}

@keyframes slidein {
  0% {
    transform: scale(0.95);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.95);
  }
}

::v-deep .van-sku-stepper-stock {
  display: none;
}
</style>
